module.exports = __webpack_public_path__ + "static/patterns-abstract.8a65b981.svg";